












import { Subscription } from 'rxjs/Subscription';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class ScrollToTop extends Vue {
  @Prop({ default: 1000 })
  private scrollPixelsToShow: number;

  private show = false;

  private scrollSubscription: Subscription;

  mounted() {
    this.scrollSubscription = this.$x.on(EVENTS.Scroll)
      .subscribe((scroll: number) => this.show = scroll > this.scrollPixelsToShow);
  }

  destroyed() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  scrollToTop() {
    this.$x.emit(EVENTS.ScrollTo, 0);
  }
}
